import React from 'react';
import type { ReactNode } from 'react';
import type { CoreProps } from '@balance-web/core';

import { ThemeProvider } from './ThemeProvider';
import { PackageProviders } from './PackageProviders';
import type { ThemeProviderProps } from './ThemeProvider';

type ReckonBalanceCoreProps = {
  themeMode: 'light';
  children?: ReactNode;
} & Pick<
  ThemeProviderProps,
  | 'linkComponent'
  | 'themeOverrides'
  | 'fastMode'
  | 'portalParent'
  | 'portalParentElement'
> &
  Pick<CoreProps, 'globalStyles' | 'appType'>;

export const ReckonBalanceCore = ({
  themeOverrides,
  linkComponent,
  globalStyles,
  fastMode,
  portalParent,
  portalParentElement,
  children,
  appType,
}: ReckonBalanceCoreProps) => {
  return (
    <ThemeProvider
      appType={appType}
      fastMode={fastMode}
      globalStyles={globalStyles}
      linkComponent={linkComponent}
      portalParent={portalParent}
      portalParentElement={portalParentElement}
      themeOverrides={themeOverrides}
    >
      <PackageProviders>{children}</PackageProviders>
    </ThemeProvider>
  );
};
